/* jshint undef: true, unused: true */
/* globals require, customCodes, dropdownData */

var FoBuComponentFactory = require('./fobu-component-factory');

function createLegacyDropDownComponent (element, componentSettings, selectedOption, foBu) {

  var legacyDropDownInitFunction = 'initDropdown(jQuery(this));',
      name                       = foBu.getInputName(componentSettings.attributes.name),
      inputElement               = document.createElement('input'),
      dropDownSelector           = createSelectOptionsButton(name, foBu),
      legacyInputAttributes      = {
        'data-custom-codes' : true,
        'id'                : name + '_title',
        'name'              : name,
        'data-field-id'     : name,
        'data-field-name'   : name,
        'data-unique-id'    : name,
        'autocomplete'      : 'off'
      };

  selectedOption = foBu.existingValues[componentSettings.attributes.name];

  element.classList.add('dropdown-wrapper');

  dropdownData[name] = {
    field       : name,
    fieldId     : name,
    cacheCodes  : false,
    customCodes : true
  };

  customCodes[name] = [];

  Object.keys(legacyInputAttributes).map(function (key) {
    var attributeValue = legacyInputAttributes[key];
    inputElement.setAttribute(key, attributeValue);
  });

  inputElement.setAttribute('onfocus', legacyDropDownInitFunction);

  element.classList.remove('form-control');
  if (componentSettings.comboWrapperClass) {
    element.classList.add(componentSettings.comboWrapperClass);
  }
  ['form-control', 'form-input', '__typeahead--display'].forEach(function (className) {
    inputElement.classList.add(className);
  });

  var options = componentSettings.options
    // Maps against some validation steps to ensure the config is valid.
    .map((option, idx) => {
      if (typeof option !== 'object') {
        throw `Option ${idx} provided to typeahead ${name} expected to be an object. ${typeof option} found.`;
      }
      if (typeof option.value === 'undefined') {
        throw `Option ${idx} provided to typeahead ${name} lacks a value property.`;
      }
      if (typeof option.value !== 'string') {
        throw `Option ${idx} provided to typeahead ${name} has a value property which isn't a string.`;
      }
      if (typeof option.label !== 'string') {
        throw `Option ${idx} (${option.value}) provided to typeahead ${name} lacks a 'label' string property.`;
      }
      if (typeof option.active !== 'boolean') {
        throw `Option ${idx} (${option.value}) provided to typeahead ${name} lacks an 'active' boolean property.`;
      }
      return option;
    });

  function isSelectedOption(option) {
    return selectedOption && selectedOption === option.value;
  }

  function isActiveOrSelected(option) {
    return option.active || isSelectedOption(option);
  }

  function addToCustomCodes(option) {
    customCodes[name].push({ value: option.value, description: option.label });
  }

  function addAttributeToInputElement(option) {
    foBu.addAttributes(inputElement, {value : option.value});
  }

  // Handles items in list.
  options
    .filter(isActiveOrSelected)
    .forEach(addToCustomCodes);

  // Handles items which have been selected.
  options
    .filter(isSelectedOption)
    .forEach(addAttributeToInputElement);

  element.appendChild(inputElement);
  element.appendChild(dropDownSelector);

  componentSettings.inputElement = inputElement;
  componentSettings.domElement = element;
  element.foBuSettings = componentSettings;

  inputElement.id = name + '_title';
  inputElement.foBuSettings = componentSettings;

  return element;
}



function createSelectOptionsButton (elementIdentifier, foBu) {

  var showSelectOptionsButton = document.createElement('a');

  foBu.addAttributes(showSelectOptionsButton, {
    'id'              : 'img_add_' + elementIdentifier,
    'name'            : 'img_add_' + elementIdentifier,
    'data-field-id'   : elementIdentifier,
    'data-field-name' : elementIdentifier
  });

  showSelectOptionsButton.classList.add('dropdown_button_image');

  return showSelectOptionsButton;
}



function addTypeaheadOptions (element, componentSettings, selectedOption,  foBu) {

  var options = componentSettings.options,
      defaultOption = (componentSettings.attributes.placeholder || false),
      datalistElement = document.createElement('datalist');

  if (options === undefined || typeof options !== 'object') {
    throw 'FoBu configuration error: Typeahead field configurations require an object assigned to an "options" property.';
  }

  foBu.addAttributes(element, {'list' : name});

  if (defaultOption) {
    options = $.extend({}, { '': defaultOption }, options);
  }

  foBu.addAttributes(datalistElement, {'id' : name});

  element.appendChild(datalistElement);

  Object.keys(options).map(function (value) {
    var label = options[value],
        option = document.createElement('option');

    foBu.addAttributes(option, {
      'value' : value,
      'label' : label
    });

    if (defaultOption && label === defaultOption) {

      foBu.addAttributes(option, {'disabled' : 'disabled'});
      if (!selectedOption) {
        foBu.addAttributes(option, {'selected' : 'selected'});
      }
    }
    if (selectedOption && selectedOption === value) {
      foBu.addAttributes(option, {'selected' : 'selected'});
    }
    datalistElement.appendChild(option);
  });

  return element;
}



module.exports = function component (componentSettings, foBu) {

  var componentFactory = new FoBuComponentFactory(componentSettings, foBu),
      componentObject  = componentFactory.getComponentObject(),
      element          = componentObject.element,
      wrapper          = componentObject.wrapper,
      value;

  if (componentSettings.useLegacyDropDownComponent) {
    value = foBu.existingValues[name];
    element = createLegacyDropDownComponent(element, componentSettings || {}, value || null, foBu);
  } else {
    element = addTypeaheadOptions(element, componentSettings || {}, value || null, foBu);
  }

  // The 'on' property is an object which maps event names to event callbacks.
  if (componentSettings.on) {
    if (!(componentSettings.on instanceof {}.constructor)) {
      throw 'Element component structure must be an object for ' + componentSettings.label;
    }

    Object
      .entries(componentSettings.on)
      .forEach(function (entry) {
        var eventName = entry[0];

        // Event callbacks can be given as an array or a single function, to be assigned to the input element.
        var eventCallbacks = entry[1].constructor instanceof [].constructor ? entry[1] : [entry[1]];

        eventCallbacks.forEach(function (cb) {
          foBu.manageEventListener(componentSettings.inputElement, eventName, cb);
        });
      });
  }

  if(componentSettings.inputElement)
  {
    foBu.manageEventListener(componentSettings.inputElement, 'change', function (event) {
      foBu.validation.validateElement(foBu.settings.uid, event.target.name);
    });
  }

  wrapper.appendChild(element);


  return {
    wrapper           : wrapper,
    finaliseComponent : componentFactory.finaliseComponent
  };
};
